import { BankSlipType } from './type'
import Visual from './Visual'

const BankSlip = ({ paymentMethod }: BankSlipType) => {
  return <Visual paymentMethod={paymentMethod}/>
}

export default BankSlip
